<igo-entity-table
  #table
  class="table-compact"
  [store]="mapProximityState.proximityFeatureStore"
  [template]="tableTemplate"
/>
<br />
@if (mapProximityState.currentPositionCoordinate$ | async; as coord) {
  <mat-form-field class="coordinates">
    <textarea
      #textArea
      matInput
      readonly
      rows="1"
      [placeholder]="'igo.integration.map-proximity-tool.lon' | translate"
      [value]="coord[0]"
    ></textarea>
  </mat-form-field>
}
@if (mapProximityState.currentPositionCoordinate$ | async; as coord2) {
  <mat-form-field class="coordinates2">
    <textarea
      #textArea
      matInput
      readonly
      rows="1"
      [placeholder]="'igo.integration.map-proximity-tool.lat' | translate"
      [value]="coord2[1]"
    ></textarea>
  </mat-form-field>
}

@if (
  (mapProximityState.currentPositionCoordinate$ | async) &&
  (mapProximityState.currentPositionCoordinate$ | async).length
) {
  <button mat-icon-button (click)="copyTextToClipboard()">
    <mat-icon>content_copy</mat-icon>
  </button>
}
<div class="title-container">
  <mat-label class="title">{{
    'igo.integration.map-proximity-tool.method' | translate
  }}</mat-label>
</div>
<div class="igo-input-container">
  <mat-radio-group (change)="onLocationTypeChange($event)">
    <mat-radio-button
      [checked]="
        (mapProximityState.proximitylocationType$ | async) === 'geolocation'
      "
      value="geolocation"
      >{{
        'igo.integration.map-proximity-tool.geolocation' | translate
      }}</mat-radio-button
    >
    <mat-radio-button
      [checked]="
        (mapProximityState.proximitylocationType$ | async) === 'mapCenter'
      "
      value="mapCenter"
      >{{
        'igo.integration.map-proximity-tool.mapCenter' | translate
      }}</mat-radio-button
    >
  </mat-radio-group>
</div>

<div class="radius-unit">
  <mat-form-field class="radius-field" floatLabel="always">
    <mat-label>{{
      'igo.integration.map-proximity-tool.radiusM' | translate
    }}</mat-label>
    <input
      type="number"
      pattern="[0-9]*"
      [(ngModel)]="maxDistance"
      matInput
      placeholder="{{
        'igo.integration.map-proximity-tool.radiusM' | translate
      }}"
    />
  </mat-form-field>
</div>
